"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var TransactionRequest_1 = require("../../TransactionRequest");
var LitecoinTransactionRequest = /** @class */ (function (_super) {
    tslib_1.__extends(LitecoinTransactionRequest, _super);
    function LitecoinTransactionRequest() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return LitecoinTransactionRequest;
}(TransactionRequest_1.TransactionRequest));
exports.LitecoinTransactionRequest = LitecoinTransactionRequest;
//# sourceMappingURL=LitecoinTransactionRequest.js.map